import fhirActionTypes from './actionTypes';
import { createAsyncRequestReducer } from '../../util/fetchReducers';
import { combineReducers } from 'redux';

export const reducers = {
  conditions: createAsyncRequestReducer(fhirActionTypes.FETCH_CONDITIONS),
  condition: createAsyncRequestReducer(fhirActionTypes.FETCH_CONDITION),
  encounters: createAsyncRequestReducer(fhirActionTypes.FETCH_ENCOUNTERS),
  immunizations: createAsyncRequestReducer(fhirActionTypes.FETCH_IMMUNIZATIONS),
  immunization: createAsyncRequestReducer(fhirActionTypes.FETCH_IMMUNIZATION),
  observations: createAsyncRequestReducer(fhirActionTypes.FETCH_OBSERVATIONS),
  observation: createAsyncRequestReducer(fhirActionTypes.FETCH_OBSERVATION),
  patients: createAsyncRequestReducer(fhirActionTypes.FETCH_PATIENTS),
  patient: createAsyncRequestReducer(fhirActionTypes.FETCH_PATIENT),
  procedures: createAsyncRequestReducer(fhirActionTypes.FETCH_PROCEDURES),
  procedure: createAsyncRequestReducer(fhirActionTypes.FETCH_PROCEDURE),
  sequences: createAsyncRequestReducer(fhirActionTypes.FETCH_SEQUENCES),
  sequence: createAsyncRequestReducer(fhirActionTypes.FETCH_SEQUENCE),
  documentReferences: createAsyncRequestReducer(
    fhirActionTypes.FETCH_DOCUMENT_REFERENCES,
  ),
  documentReference: createAsyncRequestReducer(
    fhirActionTypes.FETCH_DOCUMENT_REFERENCE,
  ),
  media: createAsyncRequestReducer(fhirActionTypes.FETCH_MEDIA),
  medium: createAsyncRequestReducer(fhirActionTypes.FETCH_MEDIUM),
  variants: createAsyncRequestReducer(fhirActionTypes.FETCH_PATIENT_VARIANTS),
  medicationStatements: createAsyncRequestReducer(
    fhirActionTypes.FETCH_PATIENT_MEDICATION_STATEMENTS,
  ),
  medicationAdministrations: createAsyncRequestReducer(
    fhirActionTypes.FETCH_PATIENT_MEDICATION_ADMINISTRATIONS,
  ),
  medicationRequests: createAsyncRequestReducer(
    fhirActionTypes.FETCH_PATIENT_MEDICATION_REQUESTS,
  ),
  graphQLRequest: createAsyncRequestReducer(fhirActionTypes.FETCH_FHIR_GRAPHQL),
  diagnosticReports: createAsyncRequestReducer(
    fhirActionTypes.FETCH_DIAGNOSTIC_REPORTS,
  ),
  questionnaires: createAsyncRequestReducer(
    fhirActionTypes.FETCH_QUESTIONNAIRES,
  ),
  questionnaire: createAsyncRequestReducer(fhirActionTypes.FETCH_QUESTIONNAIRE),
  createQuestionnaire: createAsyncRequestReducer(
    fhirActionTypes.CREATE_QUESTIONNAIRE,
  ),
  updateQuestionnaire: createAsyncRequestReducer(
    fhirActionTypes.UPDATE_QUESTIONNAIRE,
  ),
  consents: createAsyncRequestReducer(fhirActionTypes.FETCH_CONSENTS),
};
export default combineReducers(reducers);
